namespace GeniuzPOS.SalePromoCamp {
    export interface PsPromoDtForm {
        ItemType: Serenity.EnumEditor;
        ItemCode: Serenity.StringEditor;
        ItemId: Serenity.LookupEditor;
        PromoType: Serenity.EnumEditor;
        PromoDiscPc: Serenity.DecimalEditor;
        GroupCode1: Serenity.StringEditor;
        DescItem: Serenity.StringEditor;
        PromoPrice: Serenity.DecimalEditor;
        GpNormal: Serenity.DecimalEditor;
        GpPromo: Serenity.DecimalEditor;
    }

    export class PsPromoDtForm extends Serenity.PrefixedContext {
        static formKey = 'SalePromoCamp.PsPromoDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPromoDtForm.init)  {
                PsPromoDtForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.StringEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(PsPromoDtForm, [
                    'ItemType', w0,
                    'ItemCode', w1,
                    'ItemId', w2,
                    'PromoType', w0,
                    'PromoDiscPc', w3,
                    'GroupCode1', w1,
                    'DescItem', w1,
                    'PromoPrice', w3,
                    'GpNormal', w3,
                    'GpPromo', w3
                ]);
            }
        }
    }
}
